import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export interface LegacyRedirectProps {
    to: string | ((params: Record<string, string | undefined>) => string);
}

export const LegacyRedirect = (props: LegacyRedirectProps) => {
    const params = useParams();
    const location = useLocation();
    const target = typeof props.to === 'function' ? props.to(params) : props.to;
    return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
};
